import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

import styles from './PrivacyPolicy.module.scss';

const PrivacyPolicyPage: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <ReactMarkdown>{t('meterkast:privacyPolicy')}</ReactMarkdown>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
